import RowDefiner from '../../CustomCells/RowDefiner/RowDefiner';
import './RowDefinerColumn.scss';

const RowDefinerColumn = (isOrderByUbication) => ({
  cellClassName: `row-definer-column ${isOrderByUbication === 'true' ? 'ubication' : 'position'}`,
  component: ({ rowData }) => (
    <RowDefiner
      // If the row definition is a work line
      lineBlockedBySap={rowData?.lineBlockedBySap}
      nameLine={rowData?.nameLine}
      namePosition={rowData.namePosition}
      numberLine={rowData?.numberLine}
      numberPosition={rowData?.numberPosition}
      // If the row definition is a location
      ubicationFinished={rowData?.ubicationFinished}
      ubicationName={rowData?.ubicationName}
      unitMeasurement={rowData?.unitMeasurement}
    />
  ),
  copyValue: () => '',
  deleteValue: () => '',
  disabled: true,
  headerClassName: `row-definer-header ${isOrderByUbication === 'true' ? 'ubication' : 'position'}`,
  minWidth: 340,
  pasteValue: () => ''
});

export default RowDefinerColumn;
